import {omit} from 'lodash-es';

import {ERequestType} from 'shared/types/requests';
import {IRpcDeleteResponse} from 'shared/types/rpc';
import {performRequest} from 'shared/utils';

import {REPORT_CONFIGURATION_API_URL_ENDPOINT} from '../report-configuration-constants';
import {IReportDdReferenceRule, IReportDdReferenceRulesFilter, ITotalRowDto} from './dd-references-configuration-types';

const ddReferenceRulesApiEndpoint = `${REPORT_CONFIGURATION_API_URL_ENDPOINT}/table.report.drill.down`;

interface IFetchDrillDownReferenceRulesResponse {
    dataTable: IReportDdReferenceRule[];
    recordsTotal: number;
}
export const fetchDrillDownReferenceRules = (
    params?: IReportDdReferenceRulesFilter,
) => performRequest<IFetchDrillDownReferenceRulesResponse>({
    url: ddReferenceRulesApiEndpoint,
    method: 'GET',
    params,
});

export const fetchDrillDownReferenceRuleById = ({id}: {id: number}) => performRequest<IReportDdReferenceRule>({
    url: [ddReferenceRulesApiEndpoint, id].join('/'),
    method: 'GET',
});

export type TDrillDownReferenceRulePostRequestArgs = Partial<Omit<IReportDdReferenceRule, 'id'>>;
export const postDrillDownReferenceRule = (
    args: TDrillDownReferenceRulePostRequestArgs,
) => performRequest<IReportDdReferenceRule>({
    url: [ddReferenceRulesApiEndpoint].join('/'),
    method: 'POST',
    data: args,
});

export type TDrillDownReferenceRulePutRequestArgs = Partial<IReportDdReferenceRule>;
export const putDrillDownReferenceRule = (
    args: TDrillDownReferenceRulePutRequestArgs,
) => performRequest<IReportDdReferenceRule>({
    url: [ddReferenceRulesApiEndpoint, args.id].join('/'),
    method: 'PUT',
    data: omit(args, 'id'),
});

export type TDrillDownReferenceRuleDeleteRequestArgs = {ids: number[]};
export const deleteDrillDownReferenceRulesRequest = (
    args: TDrillDownReferenceRuleDeleteRequestArgs,
) => performRequest<IRpcDeleteResponse>({
    url: [ddReferenceRulesApiEndpoint, 'rpc', 'delete-list'].join('/'),
    method: 'POST',
    data: args,
});

export type TDrillDownReferenceRuleUpdateTotalRowRequestArgs = {data: {totalRowDto: ITotalRowDto}; id: number};
export const updateTotalRow = async ({
    data,
    id,
}: TDrillDownReferenceRuleUpdateTotalRowRequestArgs) => performRequest({
    url: `administration.report.configuration/table.report.drill.down/${id}`,
    method: ERequestType.PATCH,
    data,
});
